import React from 'react';
interface BoundingBoxPropT {
  strokeColor?: string;
  fillColor?: string;
}
const BoundingBox = ({
  strokeColor,
  fillColor = 'none'
}: BoundingBoxPropT) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="1" y="1" width="22" height="22" rx="11" stroke={strokeColor ? strokeColor : 'currentColor'} strokeWidth="2" strokeDasharray="2 2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.33334 5.33337V15.3456L11.8364 12.8426L13.9223 17.0143C13.9223 17.0143 14.4866 17.1944 14.7566 17.0143C15.0267 16.8343 15.2954 16.4717 15.1738 16.18C14.6001 14.803 13.0879 12.0082 13.0879 12.0082H16.0082L9.33334 5.33337Z" fill={strokeColor ? strokeColor : 'currentColor'} />
    </svg>;
};
export { BoundingBox };